module.exports = __webpack_public_path__ + "static/media/CTLA_5-135w.7c8167a6.jpg";